export default {
  WORKFLOW: {
    color: 'green',
    shortName: 'Manual',
    name: 'Manual Campaign',
    fullName: 'Manual Influencer Campaign',
  },
  AUTOMATED: {
    color: 'pink',
    shortName: 'Automated',
    name: 'Automated Campaign',
    fullName: 'Automated Influencer Campaign',
  },
  ACR: {
    color: 'orange',
    shortName: 'ACR',
    name: 'Automated Channel Report',
    fullName: 'Automated Channel Report',
  },

};



/** WEBPACK FOOTER **
 ** ./src/utils/campaign-types.js
 **/